var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "registry-operations" },
    [
      _vm.section === "imports"
        ? _c("RegistryOperationImports", {
            ref: "imports",
            attrs: {
              "can-update": _vm.canUpdate,
              metadata: _vm.metadata,
              "before-navigate": _vm.beforeNavigate,
            },
            on: {
              state: _vm.onChildState,
              changed: function ($event) {
                return _vm.$emit("changed", $event)
              },
            },
          })
        : [
            _vm.section === "entities"
              ? [
                  _c(
                    "b-form",
                    {
                      staticClass: "row align-items-end",
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.searchEntities.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "col-sm-3",
                          attrs: {
                            label: "Record type",
                            "label-for": "registry-entity-type",
                          },
                        },
                        [
                          _c("b-form-select", {
                            key: _vm.controlVersion,
                            attrs: {
                              id: "registry-entity-type",
                              value: _vm.filters.type,
                              options: _vm.entityTypes,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.changeFilter("type", $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          staticClass: "col-sm-6",
                          attrs: {
                            label: "Search by name",
                            "label-for": "registry-entity-name",
                          },
                        },
                        [
                          _c(
                            "b-input-group",
                            [
                              _c("b-form-input", {
                                attrs: { id: "registry-entity-name" },
                                model: {
                                  value: _vm.searchText,
                                  callback: function ($$v) {
                                    _vm.searchText = $$v
                                  },
                                  expression: "searchText",
                                },
                              }),
                              _c(
                                "b-input-group-append",
                                [
                                  _c(
                                    "b-btn",
                                    {
                                      attrs: {
                                        type: "submit",
                                        variant: "outline-primary",
                                        disabled: _vm.loading,
                                      },
                                    },
                                    [_vm._v("Search")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-sm-3 mb-3" },
                        [
                          _c(
                            "b-btn",
                            {
                              attrs: {
                                variant: "primary",
                                disabled: !_vm.canUpdate || _vm.busy,
                              },
                              on: { click: _vm.addEntity },
                            },
                            [_vm._v("Add " + _vm._s(_vm.filters.type))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("details", { staticClass: "mb-3" }, [
                    _c("summary", [_vm._v("More filters")]),
                    _c(
                      "div",
                      { staticClass: "row mt-2" },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "col-sm-3",
                            attrs: {
                              label: "Address / operation state",
                              "label-for": "registry-entity-state",
                            },
                          },
                          [
                            _c("b-form-input", {
                              key: `state-${_vm.controlVersion}`,
                              attrs: {
                                id: "registry-entity-state",
                                value: _vm.filters.state,
                                maxlength: "2",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.changeFilter("state", $event)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            staticClass: "col-sm-3",
                            attrs: {
                              label: "Added via",
                              "label-for": "registry-entity-origin",
                            },
                          },
                          [
                            _c("b-form-select", {
                              key: `origin-${_vm.controlVersion}`,
                              attrs: {
                                id: "registry-entity-origin",
                                value: _vm.filters.origin,
                                options: _vm.originOptions,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.changeFilter("origin", $event)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            staticClass: "col-sm-3",
                            attrs: {
                              label: "Link resolution",
                              "label-for": "registry-entity-resolution",
                            },
                          },
                          [
                            _c("b-form-select", {
                              key: `resolution-${_vm.controlVersion}`,
                              attrs: {
                                id: "registry-entity-resolution",
                                value: _vm.filters.link_resolution,
                                options: _vm.resolutionOptions,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.changeFilter(
                                    "link_resolution",
                                    $event
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            staticClass: "col-sm-3",
                            attrs: {
                              label: "Exact supplier identity",
                              "label-for": "registry-entity-source",
                            },
                          },
                          [
                            _c("b-form-input", {
                              key: `source-${_vm.controlVersion}`,
                              attrs: {
                                id: "registry-entity-source",
                                value: _vm.filters.source_record_id,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.changeFilter(
                                    "source_record_id",
                                    $event
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              : _c(
                  "b-form-group",
                  {
                    staticClass: "registry-conflict-filter",
                    attrs: {
                      label: "Conflict status",
                      "label-for": "registry-conflict-status",
                    },
                  },
                  [
                    _c("b-form-select", {
                      key: _vm.controlVersion,
                      attrs: {
                        id: "registry-conflict-status",
                        value: _vm.conflictStatus,
                        options: _vm.conflictStatuses,
                      },
                      on: { change: _vm.changeConflictStatus },
                    }),
                  ],
                  1
                ),
            _vm._v(" "),
            _vm.loading
              ? _c("p", { attrs: { role: "status" } }, [
                  _vm._v("Loading " + _vm._s(_vm.section) + "..."),
                ])
              : _vm.error
              ? _c(
                  "b-alert",
                  { attrs: { show: "", variant: "danger", role: "alert" } },
                  [
                    _vm._v(_vm._s(_vm.error) + " "),
                    _c(
                      "b-btn",
                      {
                        attrs: { variant: "link", size: "sm" },
                        on: { click: _vm.retry },
                      },
                      [_vm._v("Retry")]
                    ),
                  ],
                  1
                )
              : _vm.loaded
              ? [
                  _c(
                    "p",
                    {
                      staticClass: "small text-muted",
                      attrs: { "aria-live": "polite" },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.meta.total || 0) +
                          " " +
                          _vm._s(
                            _vm.section === "entities"
                              ? "matching records"
                              : "conflicts"
                          )
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.items.length
                    ? _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.section === "entities"
                              ? "No records match these filters."
                              : "No conflicts match this status."
                          )
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.section === "entities"
                    ? _vm._l(_vm.items, function (item) {
                        return _c(
                          "article",
                          {
                            key: `${item.type}:${item.id}`,
                            staticClass: "registry-operation-row",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "registry-operation-main" },
                              [
                                _c(
                                  "b-btn",
                                  {
                                    staticClass:
                                      "p-0 text-left font-weight-bold",
                                    attrs: { variant: "link" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openEntity(item)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.entityName(item)))]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "small text-muted" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.entityAddress(item) || "No address"
                                    )
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "small text-muted" },
                              [
                                _vm._v(
                                  _vm._s(_vm.label(item.type)) +
                                    " · " +
                                    _vm._s(item.state || "No state") +
                                    " · " +
                                    _vm._s(
                                      item.origin === "manual"
                                        ? "Administrator"
                                        : "Import"
                                    ) +
                                    "\n            "
                                ),
                                _vm._l(
                                  item.link_counts || {},
                                  function (count, resolution) {
                                    return count
                                      ? _c("div", { key: resolution }, [
                                          _vm._v(
                                            _vm._s(count) +
                                              " " +
                                              _vm._s(_vm.label(resolution))
                                          ),
                                        ])
                                      : _vm._e()
                                  }
                                ),
                              ],
                              2
                            ),
                          ]
                        )
                      })
                    : _vm._l(_vm.items, function (conflict) {
                        return _c(
                          "article",
                          {
                            key: conflict.id,
                            staticClass:
                              "registry-operation-row align-items-start",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "registry-operation-main" },
                              [
                                _c(
                                  "b-btn",
                                  {
                                    staticClass:
                                      "p-0 text-left font-weight-bold",
                                    attrs: { variant: "link" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openLicense(
                                          conflict.original_license_id
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.identity({
                                          ...conflict.original_identity,
                                          original_number:
                                            conflict.original_number,
                                        })
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "small" }, [
                                  _vm._v(
                                    "Incoming: " +
                                      _vm._s(
                                        _vm.identity(conflict.asserted_identity)
                                      ) +
                                      " · " +
                                      _vm._s(
                                        _vm.readable(
                                          (conflict.disputed_version || {})
                                            .legal_name || "No reported name"
                                        )
                                      )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "small text-muted" }, [
                                  _vm._v(
                                    _vm._s(_vm.label(conflict.status)) +
                                      " · " +
                                      _vm._s(_vm.dateTime(conflict.since))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("details", { staticClass: "small mt-2" }, [
                                  _c("summary", [
                                    _vm._v("Evidence and resolution history"),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "mt-2" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.readable(
                                          (conflict.disputed_version || {})
                                            .status_raw || "No reported status"
                                        )
                                      ) +
                                        " · Expiration " +
                                        _vm._s(
                                          _vm.readable(
                                            (conflict.disputed_version || {})
                                              .expiration_raw || "Not supplied"
                                          )
                                        )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "pre",
                                    {
                                      staticClass:
                                        "registry-operation-evidence",
                                    },
                                    [_vm._v(_vm._s(_vm.evidence(conflict)))]
                                  ),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            conflict.status === "open"
                              ? _c(
                                  "b-btn",
                                  {
                                    attrs: {
                                      size: "sm",
                                      variant: "outline-primary",
                                      disabled: !_vm.canUpdate || _vm.busy,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.resolve(conflict)
                                      },
                                    },
                                  },
                                  [_vm._v("Resolve")]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                  _vm._v(" "),
                  _vm.meta.total > (_vm.meta.per_page || 25)
                    ? _c("b-pagination", {
                        key: `page-${_vm.controlVersion}`,
                        staticClass: "mt-3",
                        attrs: {
                          value: _vm.page,
                          "total-rows": _vm.meta.total,
                          "per-page": _vm.meta.per_page || 25,
                        },
                        on: { input: _vm.changePage },
                      })
                    : _vm._e(),
                ]
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }